import { useLayoutEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import AuthAxios from '../axios';
import { getToken, USERTOKEN } from '../utils/localStorage';

const LEGAL_APP_SEGMENTS = new Set([
  'terms-of-use',
  'privacy-policy',
  'privacy-policy-en',
  'marketing-information',
]);

/** 로그인 토큰이 있을 때만 세션 유효성 검사 — 비로그인·검색 봇은 공개 페이지 유지 */
export default function RouteGuard() {
  const location = useLocation();
  const navigate = useNavigate();
  useLayoutEffect(() => {
    const segments = location.pathname.split('/').filter(Boolean);
    const prefixPath = segments[0] || '';
    const secondPath = segments[1] || '';

    if (prefixPath !== 'app' || LEGAL_APP_SEGMENTS.has(secondPath)) {
      return;
    }

    if (!getToken(USERTOKEN)) {
      return;
    }

    AuthAxios.get(`/users`)
      .then((response) => {
        if (!response.data) {
          navigate('/auth');
        }
      })
      .catch(() => {
        navigate('/auth');
      });
  }, [location, navigate]);
  return null;
}
